import React from 'react';
import { getStageColorV2, stageTabHeight } from '../../../../utils';
import { IStage } from '../../../../global';
import theme from '../../../../themes/CBB/theme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme: any) => ({
  stageTab: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    cursor: 'pointer',
    borderTopRightRadius: theme.spacing(1),
    borderTopLeftRadius: theme.spacing(1),
    backgroundColor: ({ stage }: any) => {
      return getStageColorV2(stage.name, theme);
    },
  },
  delete: {
    marginRight: theme.spacing(1),
    color: 'white',
    '& .MuiSvgIcon-root': {
      width: 14,
      height: 14,
    },
  },
}));

function generateWidth(stage, widthOfOneStage) {
  const widthPerc = widthOfOneStage + '%';
  if (widthOfOneStage === 100) {
    return widthPerc;
  } else if (stage['show']) {
    return `calc(${widthPerc} + 10px)`;
  } else {
    return widthPerc;
  }
}

function generateLeft(stage, widthOfOneStage, index, totalStages) {
  const leftPerc = widthOfOneStage * index + '%';
  if (index === 0) {
    return leftPerc;
  } else if (stage.show && index + 1 === totalStages) {
    return `calc(${leftPerc} - 10px)`;
  } else if (stage.show) {
    return `calc(${leftPerc} - 5px)`;
  } else {
    return leftPerc;
  }
}

function generateZIndex(stage, index) {
  if (stage.show) {
    return 101;
  } else {
    return 100 - index;
  }
}
function generateHeight(stage) {
  return stage.show ? theme.spacing(2.1) : stageTabHeight;
}

function generateMarginTop(stage) {
  return stage.show ? -theme.spacing(2.1) : -stageTabHeight;
}

function generateExtraStyles(
  stage: { show: boolean } & IStage,
  widthOfOneStage: number,
  index: number,
  totalStages: number,
) {
  return {
    width: generateWidth(stage, widthOfOneStage),
    left: generateLeft(stage, widthOfOneStage, index, totalStages),
    zIndex: generateZIndex(stage, index),
    height: generateHeight(stage),
    marginTop: generateMarginTop(stage),
  };
}

export default function StageTab({
  line,
  stage,
  totalStages,
  handleStageToShow,
  index,
  handleStageUpdate,
  editMode,
}) {
  const widthOfOneStage = 100 / totalStages;
  const classes = useStyles({
    stage,
  });

  function handleDeleteStage() {
    handleStageUpdate(stage.id, 'deleted', true);
  }

  const extraStyles = generateExtraStyles(
    stage,
    widthOfOneStage,
    index,
    totalStages,
  );

  return (
    <div
      className={classes.stageTab}
      style={extraStyles}
      onClick={() => {
        handleStageToShow(stage.id);
      }}
    >
      {line.edit && stage.show && editMode && (
        <IconButton
          className={classes.delete}
          size="small"
          onClick={handleDeleteStage}
          data-automation-id="delete"
        >
          <CancelIcon />
        </IconButton>
      )}
    </div>
  );
}
